export const ANIMAL_NAMES = [
  "Albatross",
  "Dolphin",
  "Elephant",
  "Giraffe",
  "Koala",
  "Lion",
  "Penguin",
  "Squirrel",
  "Tiger",
  "Turtle",
  "Whale",
  "Zebra",
];

export const TOOL_NAMES = [
  "Axe",
  "Chisel",
  "Drill",
  "Hammer",
  "Mallet",
  "Pliers",
  "Saw",
  "Screwdriver",
  "Wrench",
  "Blowtorch",
  "Crowbar",
  "Ladder",
];

export const WESTERN_FIRST_NAMES = [
  "Adrian",
  "Albert",
  "Alexander",
  "Alice",
  "Amanda",
  "Amy",
  "Andrew",
  "Angela",
  "Anna",
  "Anthony",
  "Benjamin",
  "Brandon",
  "Brian",
  "Caroline",
  "Catherine",
  "Charles",
  "Charlotte",
  "Christina",
  "Christopher",
  "Daniel",
  "David",
  "Diana",
  "Edward",
  "Elizabeth",
  "Emily",
  "Emma",
  "Esther",
  "Ethan",
  "George",
  "Grace",
  "Hannah",
  "Henry",
  "Isabella",
  "Jack",
  "James",
  "Jennifer",
  "Jessica",
  "John",
  "Jonathan",
  "Joseph",
  "Katherine",
  "Laura",
  "Lucas",
  "Margaret",
  "Maria",
  "Matthew",
  "Michael",
  "Nathan",
  "Nicholas",
  "Olivia",
  "Patricia",
  "Patrick",
  "Peter",
  "Rachel",
  "Rebecca",
  "Richard",
  "Robert",
  "Ruby",
  "Samuel",
  "Sarah",
  "Sebastian",
  "Sophia",
  "Stephen",
  "Thomas",
  "Victoria",
  "William",
];

export const WESTERN_LAST_NAMES = [
  "Adams",
  "Allen",
  "Anderson",
  "Baker",
  "Barnes",
  "Bell",
  "Bennett",
  "Brooks",
  "Brown",
  "Butler",
  "Campbell",
  "Carter",
  "Clark",
  "Collins",
  "Cooper",
  "Cox",
  "Crawford",
  "Davis",
  "Edwards",
  "Evans",
  "Fisher",
  "Foster",
  "Garcia",
  "Green",
  "Griffin",
  "Hall",
  "Harris",
  "Hayes",
  "Henderson",
  "Hill",
  "Howard",
  "Hughes",
  "Jackson",
  "Johnson",
  "Jones",
  "Kelly",
  "King",
  "Lee",
  "Lewis",
  "Long",
  "Martin",
  "Martinez",
  "Miller",
  "Mitchell",
  "Moore",
  "Morgan",
  "Morris",
  "Murphy",
  "Nelson",
  "Parker",
  "Perry",
  "Peterson",
  "Phillips",
  "Reed",
  "Roberts",
  "Robinson",
  "Rogers",
  "Ross",
  "Russell",
  "Scott",
  "Smith",
  "Stewart",
  "Sullivan",
  "Taylor",
  "Thomas",
  "Thompson",
  "Turner",
  "Walker",
  "Ward",
  "Watson",
  "White",
  "Williams",
  "Wilson",
  "Wood",
  "Wright",
  "Young",
];

export const CYRILLIC_FIRST_NAMES = [
  "Абигаил",
  "Агнес",
  "Адам",
  "Адриан",
  "Алан",
  "Александр",
  "Алиса",
  "Альберт",
  "Аманда",
  "Амелия",
  "Эми",
  "Эндрю",
];

export const CYRILLIC_LAST_NAMES = [
  "Андерсон",
  "Браун",
  "Вилсон",
  "Джексон",
  "Джонс",
  "Джонсон",
  "Дэвис",
  "Миллер",
  "Мур",
  "Смит",
  "Тейлор",
  "Томас",
  "Уайт",
  "Уильямс",
];

export const JAPANESE_FIRST_NAMES = [
  "アグネス",
  "アダム",
  "アドリアン",
  "アビゲイル",
  "アマンダ",
  "アミー",
  "アメリア",
  "アラン",
  "アリス",
  "アルバート",
  "アレクサンダー",
  "アンドリュー",
];

export const JAPANESE_LAST_NAMES = [
  "アンダーソン",
  "ウィリアムズ",
  "ウィルソン",
  "ジャクソン",
  "ジョーンズ",
  "ジョンソン",
  "スミス",
  "タイラー",
  "デイビス",
  "トーマス",
  "ブラウン",
  "ホワイト",
  "ミラー",
  "モア",
];

export const ARABIC_FIRST_NAMES = [
  "آدريان",
  "آدم",
  "آلان",
  "آلبرت",
  "آليس",
  "آماندا",
  "آمي",
  "آميليا",
  "أبيجيل",
  "أغنيس",
  "ألكسندر",
  "أندرو",
];

export const ARABIC_LAST_NAMES = [
  "أندرسون",
  "براون",
  "تايلور",
  "توماس",
  "جاكسون",
  "جونز",
  "جونسون",
  "ديفيس",
  "سميث",
  "مور",
  "ميلر",
  "وايت",
  "ويلسون",
  "ويليامز",
];

export const FIRST_NAMES = [
  ...WESTERN_FIRST_NAMES,
  ...CYRILLIC_FIRST_NAMES,
  ...JAPANESE_FIRST_NAMES,
  ...ARABIC_FIRST_NAMES,
];

export const LAST_NAMES = [
  ...WESTERN_LAST_NAMES,
  ...CYRILLIC_LAST_NAMES,
  ...JAPANESE_LAST_NAMES,
  ...ARABIC_LAST_NAMES,
];
